module.exports = __webpack_public_path__ + "img/cn.bc66d14c.svg";